import { createBrowserRouter, RouterProvider } from "react-router";

import { RequireAuth, RequireCharacter, RequireGuest, RequireNoCharacter } from "@/app/guards";
import { NotFoundPage } from "@/app/NotFoundPage";
import { AppProviders } from "@/app/providers";
import { FullScreenLoader } from "@/components/ui/FullScreenState";
import { AuthPage } from "@/features/auth/AuthPage";
import { HomePage } from "@/features/home/HomePage";
import { SystemStatusPage } from "@/features/system/SystemStatusPage";

const router = createBrowserRouter([
  {
    element: <RequireGuest />,
    children: [
      { path: "/login", element: <AuthPage mode="login" /> },
      { path: "/register", element: <AuthPage mode="register" /> },
    ],
  },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <RequireNoCharacter />,
        children: [
          {
            path: "/character/create",
            // Lazy: Three.js + the avatar only download when the studio opens.
            lazy: async () => {
              const { CharacterCreatePage } = await import("@/features/character/CharacterCreatePage");
              return { Component: CharacterCreatePage };
            },
            hydrateFallbackElement: <FullScreenLoader label="Opening the character studio…" />,
          },
        ],
      },
      {
        element: <RequireCharacter />,
        children: [
          { path: "/", element: <HomePage /> },
          {
            path: "/play",
            // Lazy: the city scene and Three.js only download when entering the city.
            lazy: async () => {
              const { PlayPage } = await import("@/features/play/PlayPage");
              return { Component: PlayPage };
            },
            hydrateFallbackElement: <FullScreenLoader label="Entering Coal City…" />,
          },
        ],
      },
    ],
  },
  { path: "/system", element: <SystemStatusPage /> },
  { path: "*", element: <NotFoundPage /> },
]);

export function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}